/**
 * GET `admin/accounts` — все люди платформы: поиск по ФИО и телефону,
 * фильтры «команда / клиенты», «работает / исключён», по клинике.
 */

import {apiEnabled, http} from '@services/utils';

import {MOCK_ACCOUNTS} from '../mocks';
import {toAccount} from '../toAccount';
import type {AccountsPage, GetAccountsRequest} from '../types';

const PAGE_SIZE = 25;
const sleep = (ms: number) => new Promise((r) => setTimeout(r, ms));

const mockPage = (req: GetAccountsRequest): AccountsPage => {
  const q = (req.query ?? '').trim().toLowerCase();
  const digits = q.replace(/\D/g, '');
  const list = MOCK_ACCOUNTS.filter(
    (a) =>
      (q === '' ||
        a.fullName.toLowerCase().includes(q) ||
        (digits !== '' && a.phone.includes(digits))) &&
      (req.isPlatformAdmin === undefined || a.isPlatformAdmin === req.isPlatformAdmin) &&
      (req.active === undefined || a.hasActiveMembership === req.active) &&
      (req.clinicId === undefined || a.memberships.some((m) => m.clinicId === req.clinicId)),
  );
  const page = req.page ?? 1;
  return {
    list: list.slice((page - 1) * PAGE_SIZE, page * PAGE_SIZE).map((a) => ({...a})),
    currentPage: page,
    pageSize: PAGE_SIZE,
    totalCount: list.length,
  };
};

export const getAccounts = async (req: GetAccountsRequest): Promise<AccountsPage> => {
  if (!apiEnabled) {
    await sleep(220);
    return mockPage(req);
  }
  const r = await http<Record<string, unknown>>('admin/accounts', {
    params: {
      query: req.query?.trim() || undefined,
      clinicId: req.clinicId,
      active: req.active,
      isPlatformAdmin: req.isPlatformAdmin,
      page: req.page ?? 1,
    },
    skipCaseConversion: true,
  });
  return {
    list: (Array.isArray(r.list) ? r.list : []).map(toAccount),
    currentPage: typeof r.currentPage === 'number' ? r.currentPage : (req.page ?? 1),
    pageSize: typeof r.pageSize === 'number' ? r.pageSize : PAGE_SIZE,
    totalCount: typeof r.totalCount === 'number' ? r.totalCount : 0,
  };
};
